import { render, staticRenderFns } from "./PaymentKagnotDetail.vue?vue&type=template&id=b421660c"
import script from "./PaymentKagnotDetail.vue?vue&type=script&lang=js"
export * from "./PaymentKagnotDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports